import { ApolloClient, ApolloError, ApolloQueryResult, FetchResult } from "@apollo/client";
import { mapAttachmentFileToTemplateAttachments } from "../../../containers/Steps/Attachments";
import { ISaveEmailTemplateResult, saveEmailTemplateMutation } from "../../../containers/TemplateWizard/graphQL";
import { ITemplateDataModel } from "../../../containers/TemplateWizard/models/Template";
import { getEmailTemplate } from "../query";
import { IEmailTemplate, IEmailTemplateResponse } from "../types";

export class EmailTemplateService {

    private apolloClient: ApolloClient<object>;

    constructor(apolloClient: ApolloClient<object>) {
        this.apolloClient = apolloClient;
    }

    public get(id: number): Promise<IEmailTemplate | undefined> {
        return new Promise<IEmailTemplate>((resolve, reject) => {
            this.apolloClient.query<IEmailTemplateResponse, any>({
                query: getEmailTemplate,
                variables: {
                    id,
                },
            }).then((response: ApolloQueryResult<IEmailTemplateResponse>) => {
                resolve(response.data.communication?.emailTemplate);
            }).catch((error: ApolloError) => {
                reject(error);
            });
        });
    }

    public save(templateID: number, template: ITemplateDataModel): Promise<ISaveEmailTemplateResult> {
        return new Promise<ISaveEmailTemplateResult>((resolve, reject) => {
            this.apolloClient.mutate<ISaveEmailTemplateResult, any>({
                mutation: saveEmailTemplateMutation,
                variables: {
                    emailTemplate: {
                        id: templateID,
                        templateName: template.TemplateName,
                        templateDetails: {
                            bCCAddressOnlyFirst: template.BCCAddressOnlyFirst,
                            cCAddressOnlyFirst: template.CCAddressOnlyFirst,
                            copyToCorrespondence: template.CopyToCorrespondence,
                            correspondenceName: template.CorrespondenceName,
                            emailBcc: template.EmailBCC,
                            emailBccAddress: template.EmailBCCAddress,
                            emailBody: template.EmailBody,
                            emailCC: template.EmailCC,
                            emailCCAddress: template.EmailCCAddress,
                            emailFromID: template.EmailFromID,
                            emailTo: template.EmailTo,
                            emailSubject: template.EmailSubject,
                            temporaryAttachmentFolder: template.TemporaryAttachmentFolder,
                            viewOnWeb: template.ViewOnWeb,
                            unlayerJsonString: JSON.stringify(template.UnlayerTemplate),
                        },
                        templateAttachments: mapAttachmentFileToTemplateAttachments(template.Attachments),
                        templateThumbnailBase64: template.TemplateThumbnailBase64,
                    },
                },
            }).then((response: FetchResult<ISaveEmailTemplateResult>) => {
                if (response.data) {
                    resolve(response.data);
                } else {
                    reject();
                }
            }).catch((error: ApolloError) => {
                reject(error);
            });
        });
    }
}
